import { render, staticRenderFns } from "./Cropper.vue?vue&type=template&id=4ecd4594&scoped=true"
import script from "./Cropper.vue?vue&type=script&lang=js"
export * from "./Cropper.vue?vue&type=script&lang=js"
import style0 from "./Cropper.vue?vue&type=style&index=0&id=4ecd4594&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ecd4594",
  null
  
)

export default component.exports